import type { DirectiveBinding } from 'vue';

type ClickOutsideElement = HTMLElement & {
    clickOutsideEvent?: (event: MouseEvent) => void;
};

const clickOutside = {
    beforeMount: (el: ClickOutsideElement, binding: DirectiveBinding<() => void>) => {
        const handler = (event: MouseEvent) => {
            if (!(el === event.target || el.contains(event.target as Node))) {
                binding.value?.();
            }
        };

        el.clickOutsideEvent = handler;
        document.addEventListener('click', handler);
    },
    unmounted: (el: ClickOutsideElement) => {
        if (el.clickOutsideEvent) {
            document.removeEventListener('click', el.clickOutsideEvent);
            delete el.clickOutsideEvent;
        }
    },
};

export default clickOutside;
